<template>
    <div class="info-detail-container">
        <!-- <div class="news-menu">
            <div class="menu-box">
                <div class="menu-item" v-for="(item, index) in category_list" :key="index" @click="choose_category(item.id)"
                     :class="item.id === selected_category_id ? 'active' : ''">{{ item.title }}</div>
            </div>
            <Button v-show="false" class="back-btn" @click="window.close()" icon="ios-arrow-back">返回</Button>
        </div> -->
        <info-header @change-cate="onCateChange" @change-sub-cate="onSubCateChange"></info-header>
        <div class="news-page-body">
            <!-- <div class="left-menu">
                <div class="menu-title">{{sel_category.title}}</div>
                <div class="menu-sub-title"></div>
                <ul>
                    <li v-for="(item, index) in sub_category_list" :key="index" @click="choose_sub_category(item.id)"
                        :class="item.id === selected_sub_category_id ? 'active' : ''">{{ item.title }}</li>
                </ul>
            </div> -->
            <div class="right-content">
                <div class="content-box">
                    <div class="content-title">
                        {{detail.title}}
                    </div>
                    <div class="content-datetime">
                        PUBLISHED {{detail.create_time | enDateNoTime}}
                    </div>
                    <div class="content" v-html="detail.content"></div>
                </div>
                <div class="prev-info" v-show="false">PREV：</div>
                <div class="next-info" v-show="false">NEXT：</div>
            </div>
            <SideMenu :mainClass="sideMenuClass"></SideMenu>
        </div>
        <div class="detail-bottom">
            <div class="bottom-box">
                <div class="box-title">
                    <div class="title">RELATED RECOMMENDATIONS</div>
                    <Button type="text" v-show="false">SEE MORE></Button>
                </div>
                <div class="item-list-box">
                    <div class="item-box" v-for="(v,k) in recommend_list" :key="`rec`+k" @click="onDetailClick(v)">
                        <img :src="v.cover|default_img" class="cover-img" />
                        <div class="title">{{v.title}}</div>
                        <div class="content">{{ v.content | plainText }}</div>
                        <div class="date-time">{{v.create_time | enDate}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SideMenu from '@/components/SideMenu/SideMenu'
import { InfoCategory, InfoDetail, InfoRecommendList } from '@/api/social'
import InfoHeader from '@/components/InfoHeader/InfoHeader'
export default {
    name: 'InfoDetail',
    components:{
        SideMenu,InfoHeader
    },
    data() {
        return {
            uuid: '',
            detail: {},
            selected_category_id: 0,
            selected_sub_category_id: 0,
            category_list: [],
            banner_list:[],
            recommend_list: [],
            isBackToTopVisible: false,
            first_enter:true
        }
    },
    computed: {
        sub_category_list() {
            let cate = this.category_list.find(v=>v.id===this.selected_category_id)
            return cate ? cate.children : []
        },
        sel_category(){
            return this.$_.cloneDeep(this.category_list.find(item => item.id === this.selected_category_id)) || {};
        },
        sideMenuClass(){
            return `position: absolute;
                    bottom: 35px;
                    right: 60px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;`
        }
    },
    beforeRouteEnter(to, from, next) {
			next((vm) => {
			// 通过 `vm` 访问组件实例
			vm.$emit("changeFooter", 'dark');
			});
		},	
    async mounted() {
        window.addEventListener('scroll', this.handleScroll);
        this.uuid = this.$route.query.uuid;
        await this.getDetail()
        // await this.getCategoryList()
        await this.getRecommendList()
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        onSubCateChange(e){
            console.log('sub-cate-change',e);
            if(this.first_enter) return;
            const {selected_category_id,selected_sub_category_id} = e;
            this.selected_category_id = selected_category_id;
            this.selected_sub_category_id = selected_sub_category_id;
            this.choose_sub_category(selected_category_id,selected_sub_category_id);
            // this.getInfiniteList(true);
        },
        onCateChange(e){
            console.log('cate-change',e);
            if(this.first_enter) return;
            const {selected_category_id,selected_sub_category_id} = e;
            this.selected_category_id = selected_category_id;
            this.selected_sub_category_id = selected_sub_category_id;
            this.choose_category(selected_category_id);
            // this.getHotList()
            // this.getInfiniteList(true);
        },
        choose_category(id) {
            this.$router.push({name: 'Info', params: {pid: id, cid: 0}})
        },
        choose_sub_category(pid,id) {
            this.$router.push({name: 'Info', params: {pid: this.detail.parent_category_id, cid: id}})
        },
        async getDetail() {
            return InfoDetail({uuid: this.uuid}).then(response => {
                this.detail = response.data
                this.selected_category_id = this.detail.parent_category_id
                this.selected_sub_category_id = this.detail.child_category_id
            }).catch((res)=>{
                this.$layer.msg(res.msg)
            }).finally(()=>{
                this.first_enter = false;
            })
        },
        async getCategoryList() {
            return InfoCategory().then(response => {
                this.category_list = response.data
            })
        },
        async getRecommendList() {
            InfoRecommendList({page: 1, limit: 5}).then(response => {
                this.recommend_list = response.data
            })
        },
        onDetailClick(item){
            window.open(`${location.protocol}//${location.host}/info/detail?uuid=${item.uuid}`)
            // this.$router.push({name:'InfoDetail',query:{uuid:item.uuid}});
        },
        handleScroll() {
            this.isBackToTopVisible = window.pageYOffset > 100; // 滚动超过 300px 显示
        },
        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        },

    }
}
</script>
<style lang="scss" scoped>
@import './InfoDetail.scss'
</style>
